import { otherColors } from '@ehrTheme/colors';
import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface CompleteConfigurationProps {
  handleSetup: () => void;
}

export const CompleteConfiguration: FC<CompleteConfigurationProps> = ({ handleSetup }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: otherColors.orange100,
        px: '20px',
        py: '10px',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
      }}
    >
      <Typography variant="body1">
        <span style={{ fontWeight: 'bold' }}>{t('common.configuration.title')}</span>
        <br />
        {t('common.configuration.description')}
      </Typography>
      <Button
        sx={{
          backgroundColor: otherColors.orange800,
          color: '#FFFFFF',
          borderRadius: '100px',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: otherColors.orange700,
          },
        }}
        onClick={() => handleSetup()}
      >
        {t('common.configuration.button')}
      </Button>
    </Box>
  );
};
